export default __webpack_public_path__ + "static/media/profile.b45ff9ca.jpg";